import { get } from "@s-libs/micro-dash";

import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";
import ADMIN_CONSOLE_ROUTE_CONTENTS from "../../constants/AdminConsoleRouteContents";
import ADMIN_CONSOLE_ROUTES from "../../constants/AdminConsoleRoutes";

const menuOptions = [
  {
    href: ADMIN_CONSOLE_ROUTES.ADMIN_CONSOLE,
    contents: ADMIN_CONSOLE_ROUTE_CONTENTS.ADMIN_CONSOLE,
  },
  {
    href: ADMIN_CONSOLE_ROUTES.REPORTING,
    contents: ADMIN_CONSOLE_ROUTE_CONTENTS.REPORTING,
  },
  {
    href: ADMIN_CONSOLE_ROUTES.CONTENT_ADVISORY,
    contents: ADMIN_CONSOLE_ROUTE_CONTENTS.CONTENT_ADVISORY,
  },
  {
    href: ADMIN_CONSOLE_ROUTES.SCHOOLS,
    contents: ADMIN_CONSOLE_ROUTE_CONTENTS.SCHOOLS,
  },
  {
    href: ADMIN_CONSOLE_ROUTES.CLASS_ROOMS,
    contents: ADMIN_CONSOLE_ROUTE_CONTENTS.CLASS_ROOMS,
  },
  {
    href: ADMIN_CONSOLE_ROUTES.TEACHERS,
    contents: ADMIN_CONSOLE_ROUTE_CONTENTS.TEACHERS,
  },
  {
    href: ADMIN_CONSOLE_ROUTES.STUDENTS,
    contents: ADMIN_CONSOLE_ROUTE_CONTENTS.STUDENTS,
  },
];

const hasContentAdvisoryPrivileges = (features) =>
  get(features, ["content_advisory_upload"], "off") === "on";

const useAdminConsoleBreadcrumbsLinks = (section, subsection) => {
  const { data: user } = useUser();
  const { isAuthorizedDistrictAdmin, hasTeacherRole } = getUserProperties(user);
  // eslint-disable-next-line prefer-const
  let links = [
    {
      href: "#",
      contents: "Menu",
      disclosureLinks: menuOptions.filter((child) => {
        const { contents } = child;
        // Show Content advisory link to eligible district leader only.
        if (
          contents === ADMIN_CONSOLE_ROUTE_CONTENTS.CONTENT_ADVISORY &&
          (!isAuthorizedDistrictAdmin ||
            (isAuthorizedDistrictAdmin &&
              !hasContentAdvisoryPrivileges(user.features)))
        )
          return false;
        if (contents === ADMIN_CONSOLE_ROUTE_CONTENTS.REPORTING) return false;
        // Show Profile link to teachers only.
        if (
          contents === ADMIN_CONSOLE_ROUTE_CONTENTS.PROFILE &&
          !hasTeacherRole
        )
          return false;

        return true;
      }),
    },
    {
      href: section?.href,
      contents: section?.contents,
    },
  ];

  if (subsection) {
    links.push({
      href: subsection.href,
      contents: subsection.contents,
    });
  }

  return links;
};

export default useAdminConsoleBreadcrumbsLinks;
